import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

// Logical area: IconNotificationSignal UI Strings
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.icons.icon-notification-signal.';

  public static readonly systemOnline = `${Id.prefix}systemOnline`;
  public static readonly systemOffline = `${Id.prefix}systemOffline`;
  public static readonly receivingUpdates = `${Id.prefix}receivingUpdates`;
  public static readonly serviceRestarting = `${Id.prefix}serviceRestarting`;
}

export class LangIconNotificationSignal {
  private constructor() {}
  public static systemOnline(): string {
    return interpolate(Id.systemOnline);
  }
  public static systemOffline(): string {
    return interpolate(Id.systemOffline);
  }
  public static receivingUpdates(): string {
    return interpolate(Id.receivingUpdates);
  }
  public static serviceRestarting(): string {
    return interpolate(Id.serviceRestarting);
  }
}

export class IconNotificationSignalModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // IconNotificationSignal UI Strings
    register.add(Id.systemOnline, 'System Online', 'Legend label for system online status');
    register.add(Id.systemOffline, 'System Offline. Attempting to reconnect', 'Legend label for system offline status');
    register.add(
      Id.receivingUpdates,
      'Receiving updates, page will refresh shortly',
      'Legend label for system updating status'
    );
    register.add(
      Id.serviceRestarting,
      'Service updating. Will reconnect automatically',
      'Legend label for service restarting status'
    );
  }
}
